"use client";
import Link from "next/link";
import { Button } from "@/components/atoms/button";
import { FieldGroup, Field, Label } from "@/components/atoms/fieldset";
import { InputPhone } from "@/components/molecules/phone";
import { Strong, Text } from "@/components/atoms/text";
import { FormProvider } from "react-hook-form";
import { useForgotPasswordForm } from "../hooks/useForgotPasswordForm";
import FieldErrorMessage from "@/components/molecules/error-message";

export function ForgotPasswordForm() {
  const { methods, errors, register, loading, onSubmit } =
    useForgotPasswordForm();

  return (
    <>
      <FormProvider {...methods}>
        <form aria-label="form" onSubmit={onSubmit}>
          <FieldGroup>
            <Field>
              <Label>Phone number</Label>
              <InputPhone {...register("phone")} />
              <FieldErrorMessage error={errors?.phone} />
            </Field>
          </FieldGroup>
          <div className="w-full mt-6">
            <Button
              className="w-full"
              type="submit"
              loading={loading}
              disabled={loading}>
              Send code
            </Button>
          </div>
          <Text className="text-center pt-6">
            Return to{" "}
            <Strong>
              <Link href="/login">Login</Link>
            </Strong>
          </Text>
        </form>
      </FormProvider>
    </>
  );
}
